module.exports = __webpack_public_path__ + "static/media/createQuote.77cbc0c8.svg";